"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationHouseMissing = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 1134 692",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-482.000000, -395.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(482.000000, 395.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(0.000000, 674.000000)"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M648.509648,113.10646 C584.017115,110.830839 522.587179,89.6153131 463.934941,66.4075122 C405.282702,43.199711 347.173541,17.4772149 284.230111,5.1782314 C243.739769,-2.72889045 197.43584,-3.84456498 164.815652,18.2652707 C133.41516,39.5162142 123.274768,76.2980553 117.8262,110.352692 C113.721968,136.030915 111.309285,162.99305 122.544732,187.006616 C130.352566,203.679752 144.214365,217.687665 153.802777,233.652437 C187.144099,289.214799 163.595956,357.731383 127.432418,411.98327 C110.516928,437.431275 90.8148326,461.710477 77.7364878,488.796576 C64.6581426,515.882676 58.6041777,546.92676 70.0443911,574.561841 C81.3955752,601.957849 108.424749,622.526992 137.706353,636.995343 C197.186559,666.392483 267.279009,674.804313 335.626493,679.568065 C486.922201,690.113845 639.028071,685.544895 790.724411,680.97594 C846.866032,679.275864 903.248033,677.566936 958.481559,668.721232 C989.143114,663.806949 1020.80179,656.014936 1043.05901,637.190145 C1071.32569,613.282832 1078.33226,572.844057 1059.38691,542.889084 C1027.64811,492.657163 939.803299,480.189945 917.599491,426.247966 C905.375825,396.567482 917.928897,363.504556 935.690163,335.931457 C973.794532,276.880398 1037.66386,225.072368 1041.02915,157.565205 C1043.3439,111.20273 1012.63784,64.7694186 965.16763,42.8366741 C915.400477,19.8148187 846.403081,22.7368234 809.687564,60.7937211 C771.885896,100.045985 705.452532,115.1253 648.509648,113.10646 Z",
            fill: "#1657E2",
            className: "fill-primary",
            fillRule: "nonzero",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            fill: "#10105A",
            className: "fill-secondary",
            fillRule: "nonzero",
            cx: "698",
            cy: "265",
            r: "89"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(140.000000, 351.000000)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M98,0 C138.822268,0 171.915254,33.2417776 171.915254,74.2475884 C171.915254,80.7836771 171.074477,87.1225087 169.495636,93.1609073 C185.933712,110.666717 196,134.213778 196,160.109325 C196,214.172852 152.123905,258 98,258 C43.8760945,258 0,214.172852 0,160.109325 C0,134.213778 10.0662884,110.666717 26.5034197,93.1594632 C24.9255231,87.1225087 24.0847458,80.7836771 24.0847458,74.2475884 C24.0847458,33.2417776 57.1777323,0 98,0 Z",
              fill: "#779DED",
              className: "fill-primary-opa50"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M100.886902,142 C103.652736,142 105.894886,144.242151 105.894886,147.007984 L105.893948,188.008 L128.996475,156.518421 C130.619706,154.305752 133.72204,153.812991 135.950986,155.413798 C138.151063,156.993871 138.653675,160.058288 137.073602,162.258364 C137.063973,162.271772 137.054276,162.285131 137.044512,162.29844 L106.163891,204.392645 C106.078209,204.50944 105.988407,204.621442 105.894829,204.728598 L105.894886,303.61608 C105.894886,306.381913 103.652736,308.624064 100.886902,308.624064 C98.1210689,308.624064 95.878918,306.381913 95.878918,303.61608 L95.8781587,215.847709 C95.7660473,215.754506 95.6570457,215.655656 95.5515305,215.551157 L67.4559901,187.72633 C65.5317884,185.820669 65.5167583,182.715952 67.4224194,180.79175 L67.4592503,180.754954 L67.4592503,180.754954 C69.4118157,178.824816 72.554281,178.826286 74.5050403,180.758249 L95.8779484,201.926 L95.878918,147.007984 C95.878918,144.242151 98.1210689,142 100.886902,142 Z",
              fill: "#091E43"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#D2D8E0",
            points: "372 435 714 435 640 533 292 533"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#FBFCFE",
            x: "298",
            y: "533",
            width: "343",
            height: "146"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#FBFCFE",
            points: "469.5 461 542 534 396 534"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#DEE5EB",
            transform: "translate(540.000000, 497.500000) scale(1, -1) translate(-540.000000, -497.500000) ",
            points: "540.5 461 613 534 467 534"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#DEE5EB",
            points: "641 533 712 435 786 533 786 679 641 679"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#DEE5EB",
            x: "347",
            y: "581",
            width: "50",
            height: "50"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#DEE5EB",
            x: "443",
            y: "581",
            width: "50",
            height: "98"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#DEE5EB",
            x: "542",
            y: "581",
            width: "50",
            height: "50"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "687",
            y: "581",
            width: "50",
            height: "50"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(298.000000, 435.000000)",
            stroke: "#ACB6C6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "8",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M0,244 L0,98 L73.5,0 L415,1 L488,98 L488,244 L343,244 L0,244 Z",
              strokeDasharray: "8,16"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M406.27678,11.072394 L343,98 L343,234.512769",
              strokeDasharray: "8,16"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
              x1: "22",
              y1: "98",
              x2: "333",
              y2: "98",
              strokeDasharray: "8,19"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M49,146 L99,146 L99,196 L49,196 L49,146 Z",
              strokeDasharray: "9,16"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M244,146 L294,146 L294,196 L244,196 L244,146 Z",
              strokeDasharray: "9,16"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M145,235 L145,146 L195,146 L195,235",
              strokeDasharray: "9,16"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M389,146 L439,146 L439,196 L389,196 L389,146 Z",
              strokeDasharray: "9,16"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M106.114128,89.3892307 L171,25 L234.681827,89.3892307",
              strokeDasharray: "8,16"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M185,25 L317,25 L251.284821,90.3892307",
              strokeDasharray: "8,16"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(748.000000, 288.000000)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M118,0 C167.153343,0 207,40.0705149 207,89.5 C207,97.378139 205.987798,105.018537 204.087042,112.296854 C223.878959,133.399622 236,161.784301 236,193 C236,258.1696 183.1696,311 118,311 C52.8303995,311 0,258.1696 0,193 C0,161.784301 12.1210408,133.399622 31.9132797,112.295807 C30.0122015,105.018537 29,97.378139 29,89.5 C29,40.0705149 68.8466573,0 118,0 Z",
              fill: "#779DED",
              className: "fill-primary-opa50"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M122,171 C125.313708,171 128,173.686292 128,177 L127.999462,226.501 L155.685141,188.503493 C157.622134,185.845007 161.344385,185.253754 164.009817,187.181176 C166.662895,189.099666 167.258396,192.805653 165.339907,195.458731 C165.335744,195.464487 165.331571,195.470236 165.327388,195.475978 L128.314859,246.274969 C128.214781,246.412324 128.109937,246.544161 128.00072,246.670417 L128,366 C128,369.313708 125.313708,372 122,372 C118.686292,372 116,369.313708 116,366 L115.999501,260.083276 C115.864997,259.970819 115.734273,259.851528 115.607788,259.725402 L81.9468374,226.160027 C79.6256717,223.845452 79.6203289,220.087442 81.934904,217.766276 L81.9507704,217.750424 L81.9507704,217.750424 C84.2854728,215.426702 88.0596838,215.428467 90.3922116,217.754372 L115.999462,243.289 L116,177 C116,173.686292 118.686292,171 122,171 Z",
              fill: "#091E43"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M1047.36585,606 C1083.61459,606 1113,635.325237 1113,671.49975 C1113,672.6739 1112.96904,673.840835 1112.9079,674.999785 L906.031306,675 C906.010492,674.395636 906,673.788656 906,673.179231 C906,644.425131 929.357632,621.115327 958.170732,621.115327 C971.633121,621.115327 983.904552,626.203981 993.159021,634.559023 C1004.98068,617.315288 1024.84914,606 1047.36585,606 Z",
            fill: "#1657E2",
            className: "fill-primary",
            transform: "translate(1009.500000, 640.500000) scale(-1, 1) translate(-1009.500000, -640.500000) "
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M929.365854,606 C965.614592,606 995,635.325237 995,671.49975 C995,672.6739 994.969042,673.840835 994.907896,674.999785 L788.031306,675 C788.010492,674.395636 788,673.788656 788,673.179231 C788,644.425131 811.357632,621.115327 840.170732,621.115327 C853.633121,621.115327 865.904552,626.203981 875.159021,634.559023 C886.980683,617.315288 906.849144,606 929.365854,606 Z",
            fill: "#779DED",
            className: "fill-primary-opa50"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M777.365854,606 C813.614592,606 843,635.325237 843,671.49975 C843,672.6739 842.969042,673.840835 842.907896,674.999785 L636.031306,675 C636.010492,674.395636 636,673.788656 636,673.179231 C636,644.425131 659.357632,621.115327 688.170732,621.115327 C701.633121,621.115327 713.904552,626.203981 723.159021,634.559023 C734.980683,617.315288 754.849144,606 777.365854,606 Z",
            fill: "#1657E2",
            className: "fill-primary"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M306.365854,109 C342.614592,109 372,138.325237 372,174.49975 C372,175.6739 371.969042,176.840835 371.907896,177.999785 L165.031306,178 C165.010492,177.395636 165,176.788656 165,176.179231 C165,147.425131 188.357632,124.115327 217.170732,124.115327 C230.633121,124.115327 242.904552,129.203981 252.159021,137.559023 C263.980683,120.315288 283.849144,109 306.365854,109 Z",
            fill: "#FFFFFF"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M839.365854,176 C875.614592,176 905,205.325237 905,241.49975 C905,242.6739 904.969042,243.840835 904.907896,244.999785 L698.031306,245 C698.010492,244.395636 698,243.788656 698,243.179231 C698,214.425131 721.357632,191.115327 750.170732,191.115327 C763.633121,191.115327 775.904552,196.203981 785.159021,204.559023 C796.980683,187.315288 816.849144,176 839.365854,176 Z",
            fill: "#FFFFFF",
            transform: "translate(801.500000, 210.500000) scale(-1, 1) translate(-801.500000, -210.500000) "
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M609.365854,272 C645.614592,272 675,301.325237 675,337.49975 C675,338.6739 674.969042,339.840835 674.907896,340.999785 L468.031306,341 C468.010492,340.395636 468,339.788656 468,339.179231 C468,310.425131 491.357632,287.115327 520.170732,287.115327 C533.633121,287.115327 545.904552,292.203981 555.159021,300.559023 C566.980683,283.315288 586.849144,272 609.365854,272 Z",
            fill: "#FFFFFF",
            transform: "translate(571.500000, 306.500000) scale(-1, 1) translate(-571.500000, -306.500000) "
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M169.365854,606 C205.614592,606 235,635.325237 235,671.49975 C235,672.6739 234.969042,673.840835 234.907896,674.999785 L28.0313064,675 C28.0104923,674.395636 28,673.788656 28,673.179231 C28,644.425131 51.3576322,621.115327 80.1707317,621.115327 C93.6331207,621.115327 105.904552,626.203981 115.159021,634.559023 C126.980683,617.315288 146.849144,606 169.365854,606 Z",
            fill: "#779DED",
            className: "fill-primary-opa50"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M298.365854,606 C334.614592,606 364,635.325237 364,671.49975 C364,672.6739 363.969042,673.840835 363.907896,674.999785 L157.031306,675 C157.010492,674.395636 157,673.788656 157,673.179231 C157,644.425131 180.357632,621.115327 209.170732,621.115327 C222.633121,621.115327 234.904552,626.203981 244.159021,634.559023 C255.980683,617.315288 275.849144,606 298.365854,606 Z",
            fill: "#1657E2",
            className: "fill-primary",
            transform: "translate(260.500000, 640.500000) scale(-1, 1) translate(-260.500000, -640.500000) "
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#10105A",
            className: "fill-secondary",
            fillRule: "nonzero",
            x: "0",
            y: "674",
            width: "1134",
            height: "18",
            rx: "9"
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationHouseMissing')(IllustrationHouseMissing);